/* global angular */
( function () {
	'use strict';
	function MultipleChoice ( coreservice, collectionService, templateservice, _, deepLoadingStatusService, apiService, TOOLTIP_MESSAGES, $modal ) {
		var self   = this;

		self.title = 'MultipleChoice';

		function bindOptionEntry ( model ) {
			var data        = model || {};

			data.id         = apiService.generateUUID();
			data.optionText = angular.copy( self.choice );
			data.type       = data.type || 2;
			data.selectAll  = data.selectAll || true;
			return data;
		}

		function addOptionHandler ( collection ) {
			collectionService.addModel( collection || self.model.answerOptions, bindOptionEntry() );
		}

		function removeOptionHandler ( arr, option ) {
			collectionService.removeModel( arr, option );
		}

		function addSubOptionHandler ( option ) {
			option.subOptions = option.subOptions || [];
			option.type       = option.type || 2;
			addOptionHandler( option.subOptions );
		}

		function optionFilter ( option ) {
			return option.selected;
		}

		function setScore () {
			var score    = 0;
			var selected = self.model.answerOptions.filter( optionFilter );

			_.forEach( selected, function ( select ) {
				if ( select.value ) {
					score += select.value;
				}

				if ( select.subOptions ) {
					var selectedSubOptions = select.subOptions.filter( optionFilter );

					_.forEach( selectedSubOptions, function ( subOption ) {
						if ( subOption.value ) {
							score += subOption.value;
						}
					} );
				}
			} );

			self.model.score = score;
		}

		// get options selected length
		function getSelected ( model ) {
			return model.filter( optionFilter ).length;
		}

		// check select all value if options change
		function toggleSelectAllValueHandler ( model, key ) {
			model.selectAll = getSelected( model[ key ] ) < model[ key ].length;

			// set Score
			setScore();
		}

		// perform select all/deselect all action
		function changeSelectAllHandler ( model, key ) {
			model[ key ].map( function ( option ) {
				option.selected = model.selectAll;
			} );
			model.selectAll = !model.selectAll;

			setScore();
		}

		function assignDefaultValue ( option ) {
			return ( option || {} ).value || 0;
		}

		// initialize select all value
		function initSelectAll () {
			if ( self.model ) {
				toggleSelectAllValueHandler( self.model, 'answerOptions' );
				self.model.answerOptions.map( function ( option ) {
					option.value = assignDefaultValue( option );
					if ( option.subOptions ) {
						toggleSelectAllValueHandler( option, 'subOptions' );

						option.subOptions.forEach( function ( subOption ) {
							subOption.value = assignDefaultValue( subOption );
						} );
					}
				} );
			}
		}

		// deselect other options
		function deselectOthers ( collection, model ) {
			collection.map( function ( data ) {
				if ( data.subOptions ) {
					data.subOptions.map( function ( subdata ) {
						if ( model.id !== data.id ) {
							subdata.selected = false;
						}
					} );
					toggleSelectAllValueHandler( data, 'subOptions' );
				}
				data.selected  = false;
			} );
		}

		// deselect other radio button option
		function selectRadioBtnHandler ( collection, selectOption ) {
			deselectOthers( collection, selectOption );
			selectOption.selected = true;

			// set score
			setScore();
		}

		// unset children if parent is unselected
		function parentCheckerHandler ( option ) {
			if ( !option.selected ) {
				option.selectAll = true;

				if ( option.subOptions ) {
					option.subOptions.map( function ( data ) {
						data.selected = false;
					} );
				}
			}

			setScore();
		}

		// set parent option if children is selected
		function childrenCheckerHandler ( option ) {
			if ( getSelected( option.subOptions ) > 0 ) {
				if ( self.model.type === 2 ) {
					deselectOthers( self.model.answerOptions, option );
				}
				option.selected = true;
			}

			setScore();
		}

		function deselectAllHandler () {
			if ( self.model.selectAll ) {
				self.model.answerOptions.map( function ( data ) {
					parentCheckerHandler( data );
				} );
			}

			setScore();
		}

		function optionCountHandler () {
			return self.model.answerOptions.length < 2;
		}

		function activate () {
			deepLoadingStatusService.incrementByArray( self.model, 'answerOptions', 'mc-options' );
			deepLoadingStatusService.decrementLoading( null, 'indicator' );
			initSelectAll();
		}

		function digitsOnly ( option ) {
			if ( angular.isUndefined( option.tempValue ) || String( option.tempValue ).length > 8 ) {
				option.tempValue = option.value;
			} else {
				option.value = 0;
			}

			option.value = option.tempValue;
		}

		function decrementLoadingHandler ( model ) {
			deepLoadingStatusService.incrementByArray( model, 'subOptions', 'sub-options' );
			deepLoadingStatusService.decrementLoading( null, 'mc-options' );
		}

		function changeId ( optionId, level, subOptionId ) {
			var modelData = {
				'id'          : optionId,
				'level'       : level,
				'model'       : self.model,
				'subOptionId' : subOptionId,
				'groupModel'  : self.groupModel
			};

			templateservice.changeId( modelData );
		}

		function openConfirmationModal ( model, option, type ) {
			$modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'type' : function () {
						return type;
					}
				}
			} ).result.then( function () {
				self.removeOptionHandler( model, option );
			} );
		}

		self.addOptionHandler        = addOptionHandler;
		self.removeOptionHandler     = removeOptionHandler;
		self.addSubOptionHandler     = addSubOptionHandler;
		self.changeSelectAll         = changeSelectAllHandler;
		self.toggleSelectAll         = toggleSelectAllValueHandler;
		self.optionCount             = optionCountHandler;
		self.selectRadio             = selectRadioBtnHandler;
		self.childrenChecker         = childrenCheckerHandler;
		self.parentChecker           = parentCheckerHandler;
		self.deselectAll             = deselectAllHandler;
		self.decrementLoadingHandler = decrementLoadingHandler;
		self.decrementLoading        = deepLoadingStatusService.decrementLoading;
		self.digitsOnly              = digitsOnly;
		self.changeId                = changeId;
		self.tooltip                 = TOOLTIP_MESSAGES;
		self.openConfirmationModal   = openConfirmationModal;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'MultipleChoice', MultipleChoice );

	MultipleChoice.$inject = [ 'coreservice', 'collectionService', 'templateservice', '_', 'deepLoadingStatusService', 'apiService', 'TOOLTIP_MESSAGES', '$modal' ];
} )( );
